export default "__VITE_ASSET__5d359fa4__"